module.exports = __webpack_public_path__ + "img/Autocolant TCH_55mm x 60mm-01.7f147f72.jpg";